import joinClasses from "helpers/joinClasses";

export function EmptyRestoCard({children, className="", style}){
    return(
        <div style={style} className={joinClasses(className,"border border-solid border-grey-dark rounded-xl ")}>{children}</div>
    )
}
